export interface ISelectOption {
    id: string;
    label: string;
}
